export enum ConversionCoachStatus {
  CoachNotAssigned = 1,
  CoachAssigned = 2,
}
